import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    width: 100%;
    background: ${theme.colors.background};
    border-radius: ${theme.radius.default};
    box-shadow: ${theme.shadows.flat};
    padding: 2.4rem;
    margin: 2.4rem 0;
  `}
`;

export const Content = styled.div`
  max-width: 680px;
  display: flex;
  justify-content: flex-start;
`;

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 2rem;

  @media (max-width: 1010px) {
    margin: 0 0 2rem 0;
  }
`;

export const Label = styled.label`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.default};
    color: ${theme.colors.labelInput};
  `}
`;

export const Error = styled.div`
  ${({ theme }) => css`
    width: 100%;
    padding: 10px 5px;
    display: flex;
    justify-content: center;
    color: ${theme.colors.danger};
    font-size: 16px;
    font-weight: 500;
  `}
`;
